import { Divider, Box, Heading, Text, Tag, Wrap, HStack, Badge, VStack } from '@chakra-ui/react'

import { ISharedDiagnostic } from '../../../../../types/diagnostics'
import { useTranslation } from 'react-i18next'

const SharedDiagnosticInfo = ({
  diagnosticData,
}: {
  diagnosticData: ISharedDiagnostic
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Divider my={3} />
      <Box my={4} mx={2}>
        <Heading fontFamily={'Poppins'} as={'p'} size="sm" color="purple.700" mb={3}>
          {t('sharedDiagnostic.titleInfo')}
        </Heading>
        <VStack align="stretch" spacing={4}>
          <Box
            borderWidth="1px"
            borderColor="gray.100"
            borderRadius="lg"
            p={4}
            bg="white"
            boxShadow="sm"
          >
            <HStack justify="space-between" align="start">
              <Box>
                <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="bold" letterSpacing="0.5px">
                  {t('shared.common.from')}
                </Text>
                <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                  {diagnosticData.patient?.doctor?.contactName}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  {diagnosticData.patient?.doctor?.specialty?.name}
                </Text>
              </Box>
              <Badge colorScheme="purple" variant="subtle" borderRadius="full">
                {t('shared.common.requester') || 'Requérant'}
              </Badge>
            </HStack>
          </Box>

          <Box
            borderWidth="1px"
            borderColor="gray.100"
            borderRadius="lg"
            p={4}
            bg="white"
            boxShadow="sm"
          >
            <HStack justify="space-between" align="start">
              <Box>
                <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="bold" letterSpacing="0.5px">
                  {t('shared.common.to')}
                </Text>
                {diagnosticData.receiverDoctor ? (
                  <>
                    <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                      {t('shared.common.dr')} {diagnosticData.receiverDoctor.contactName}
                    </Text>
                    <Text fontSize="sm" color="gray.600">
                      {diagnosticData.receiverDoctor.specialty?.name}
                    </Text>
                  </>
                ) : (
                  <Text fontSize="sm" color="gray.600">
                    {diagnosticData.receiverEmail}
                  </Text>
                )}
              </Box>
              <Badge colorScheme="teal" variant="subtle" borderRadius="full">
                {t('shared.common.recipient') || 'Destinataire'}
              </Badge>
            </HStack>
          </Box>

          <Box
            borderWidth="1px"
            borderColor="gray.100"
            borderRadius="lg"
            p={4}
            bg="white"
            boxShadow="sm"
          >
            <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="bold" letterSpacing="0.5px" mb={2}>
              Tags
            </Text>
            <Wrap>
              {diagnosticData.tags?.map((tag) => (
                <Tag
                  key={tag.id}
                  bgColor={`${tag.color}30`}
                  fontFamily={'Poppins'}
                  letterSpacing={'0.6px'}
                  fontSize={'small'}
                >
                  #{tag.name}
                </Tag>
              ))}
            </Wrap>
          </Box>
        </VStack>
      </Box>
    </>
  )
}

export default SharedDiagnosticInfo
